import React, { useState } from 'react';
import IssuesReportingSummary from './IssuesReportingSummary';
import DisruptionsByRoute from '../disruptionsByRoute';
import DisruptionsByHour from '../disruptionsByHour';
import DisruptionsByDay from '../disruptionsByDay';
import DisruptionsByCarrier from '../disruptionsByCarrier';
import DisruptionsByTraveler from '../disruptionsByTraveler';

interface Report {
  summary: any;
  issueResolutionsAndTypes: any;
  travelersContacted: any;
  issuesByRoute: any;
  issuesByHour: any;
  issuesByDay: any;
  issuesByCarrier: any;
  issuesByTraveler: any;
}

interface IssuesReportResultsProps {
  report: Report;
  onChartView: () => void;
}

const IssuesReportResults: React.FC<IssuesReportResultsProps> = ({ report, onChartView }) => {
  const [activeTab, setActiveTab] = useState<string>('summary');

  const handleTabChange = (tab: string, event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    event.preventDefault();
    setActiveTab(tab);
    onChartView();
  };

  return (
    <div className="report-results-data">
      <ul className="nav nav-tabs">
      <TabItem
          tab="summary"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          label="Summary"
        />
        <TabItem
          tab="byRoute"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          label="Disruptions By Route"
        />
        <TabItem
          tab="byHour"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          label="Disruptions By Hour of Day"
        />
        <TabItem
          tab="byDay"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          label="Disruptions By Day of Week"
        />
        <TabItem
          tab="byCarrier"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          label="Disruptions By Carrier"
        />
        <TabItem
          tab="byTraveler"
          activeTab={activeTab}
          onTabChange={handleTabChange}
          label="Disruptions By Traveler Email"
        />
      </ul>
      <div className="tab-content">
        {activeTab === 'summary' && (
          <IssuesReportingSummary
            summaryData={report.summary}
            issueResolutionsAndTypes={report.issueResolutionsAndTypes}
            travelersContacted={report.travelersContacted}
          />
        )}
        {activeTab === 'byRoute' && <DisruptionsByRoute data={report.issuesByRoute} />}
        {activeTab === 'byHour' && <DisruptionsByHour data={report.issuesByHour} />}
        {activeTab === 'byDay' && <DisruptionsByDay data={report.issuesByDay} />}
        {activeTab === 'byCarrier' && <DisruptionsByCarrier data={report.issuesByCarrier} />}
        {activeTab === 'byTraveler' && <DisruptionsByTraveler data={report.issuesByTraveler} />}
      </div>
    </div>
  );
};

interface TabItemProps {
  tab: string;
  activeTab: string;
  onTabChange: (tab: string, event: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
  label: string;
}

const TabItem: React.FC<TabItemProps> = ({ tab, activeTab, onTabChange, label }) => (
  <li
    className={activeTab === tab ? 'active' : ''}
    onClick={(e) => onTabChange(tab, e)}
    role="presentation"
  >
    <a href="#" role="tab" aria-selected={activeTab === tab}>
      {label}
    </a>
  </li>
);

export default IssuesReportResults;